import createPerSliceIdSelector from '../helpers/createPerSliceIdSelector';
import { getSliceContent } from './content';

export const createResponsiveSelector = combiner => createPerSliceIdSelector(
  getSliceContent,
  combiner,
);

export const resolveResponsiveSetting = (fields, settingName, resolver = setting => setting) => {
  const desktop = resolver(fields[settingName]);
  let mobile = fields[`${settingName}_mobile`];
  if (!mobile || mobile === 'Same as desktop') {
    mobile = desktop;
  } else {
    mobile = resolver(mobile);
  }
  return { desktop, mobile };
};

export const resolveAlignmentSetting = fields => (
  resolveResponsiveSetting(fields, 'alignment')
);

export const resolvePositionSetting = fields => (
  resolveResponsiveSetting(fields, 'position')
);

export const resolveIsDarkSetting = fields => (
  resolveResponsiveSetting(fields, 'theme', setting => setting === 'Dark Text')
);
